module.exports = __webpack_public_path__ + "images/b7916ea99f913a1e229c9af4ba68461f-ab-mapGrey.png";